import React from "react";
import AgentSelect from "../common/AgentSelect";
import { CITY_OPTIONS, RATING_OPTIONS } from "./hotelCatalog";

function FilterField({ label, htmlFor, className = "", children }) {
  return (
    <div className={`package-filter-bar__field ${className}`.trim()}>
      <label className="package-filter-bar__label" htmlFor={htmlFor}>{label}</label>
      {children}
    </div>
  );
}

export default function HotelFilterBar({
  search,
  onSearchChange,
  onSearchSubmit,
  filters,
  onFilterChange,
}) {
  function setField(name, value) {
    onFilterChange({ ...filters, [name]: value });
  }

  return (
    <div className="package-filter-bar package-filter-bar--hotels" role="search">
      <FilterField label="Search" htmlFor="hotel-filter-search" className="package-filter-bar__search">
        <input
          id="hotel-filter-search"
          type="search"
          className="form-control"
          placeholder="Search hotels"
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
          onBlur={() => {
            if (typeof onSearchSubmit === "function") onSearchSubmit();
          }}
          onKeyDown={(event) => {
            if (event.key === "Enter" && typeof onSearchSubmit === "function") onSearchSubmit();
          }}
        />
      </FilterField>

      <FilterField label="City" htmlFor="hotel-filter-city">
        <AgentSelect
          inputId="hotel-filter-city"
          value={filters.cityId}
          options={CITY_OPTIONS}
          onChange={(value) => setField("cityId", value)}
          placeholder="Makkah / Madinah"
          isClearable
          isSearchable={false}
        />
      </FilterField>

      <FilterField label="Ratings" htmlFor="hotel-filter-rating">
        <AgentSelect
          inputId="hotel-filter-rating"
          value={filters.rating}
          options={RATING_OPTIONS}
          onChange={(value) => setField("rating", value)}
          placeholder="Ratings"
          isClearable
          isSearchable={false}
        />
      </FilterField>

      <FilterField label="Distance" htmlFor="hotel-filter-distance-min" className="package-filter-bar__price">
        <div className="package-filter-range">
          <input
            id="hotel-filter-distance-min"
            type="number"
            min="0"
            inputMode="decimal"
            className="form-control"
            placeholder="Min"
            value={filters.distanceMin}
            onChange={(event) => setField("distanceMin", event.target.value)}
          />
          <span className="package-filter-range-sep">-</span>
          <input
            id="hotel-filter-distance-max"
            type="number"
            min="0"
            inputMode="decimal"
            className="form-control"
            placeholder="Max"
            value={filters.distanceMax}
            onChange={(event) => setField("distanceMax", event.target.value)}
          />
        </div>
      </FilterField>
    </div>
  );
}
